export default __webpack_public_path__ + "static/media/twitter.7534c92d.png";